import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import NewBrandLogo from '../../assets/images/FreightSmith_LOGO_Final.png'
import { registerCarrierEnteredMobileNumber } from '../../Utils/Utility';
import MobileInput from '../Common/MobileInput/MobileInput';
import { injectIntl } from 'react-intl';

function DriverMobile({ intl }) {

    const carrierData = useSelector(state => state.carrierLogin);
    const [mobileNumber, setMobileNumber] = useState(null);
    const [isValid, setValid] = useState(false);
    const history = useHistory();
    const { formatMessage } = intl;

    const handlePhone = (phone) => {
        setMobileNumber(phone);
    }

    const handleValid = (value) => {
        setValid(value);
    }


    const handleSubmit = (e) => {
        e.preventDefault();
            registerCarrierEnteredMobileNumber(mobileNumber);
            history.push({ pathname: '/' });
            return null;
    }

    const backHandler = () => {
        history.push({ pathname: '/' });
    }
    return (
        <form className="form-signin" action="loadStatus.html">
            <div className="card">

                <div className="card-header uc-blue"></div>

                <div className="card-header text-center bg-header">
                    <span className="text-dark-50 fa-lg">
                        <img className="img-fluid smith_logo" src={NewBrandLogo} alt="FreightSmith logo" />
                    </span>
                </div>
                <div className="card-body p-4">
                    <div className="text-center m-auto">
                        <h4 className="text-dark-50 text-center mt-0 mb-4">{formatMessage({ id: "app.driver_mobile_number" }, { strong: (...chunks) => <strong className='text-orange'>{chunks}</strong> })}</h4>

                    </div>

                    <MobileInput
                        phone={mobileNumber}
                        handlePhone={handlePhone}
                        handleValid={handleValid}
                    />
                    <button className="btn btn-chartreuse btn-height btn-block" type="submit" disabled={!isValid} onClick={handleSubmit}> {formatMessage({ id: "app.continue" })} </button>
                    <button className="btn btn-chartreuse btn-height btn-block" type="button"  onClick={backHandler}> {formatMessage({ id: "app.go_back" })} </button>
                </div>
            </div>
        </form>
    )
}

export default injectIntl(DriverMobile);